import { Avatar, Box } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { AmountWithDate } from "Components/Shared/Transactions/AmountWithDate";
import { DirectionIcon } from "Components/Shared/Transactions/DirectionIcon";
import { TransactionDetails } from "Components/Shared/Transactions/TransactionDetails";
import {
  getApiUrl,
  getMerchantsFacilitiesFacilityPublicIDLogoPath,
  TransactionDirection,
  type TransactionItem as TransactionItemType,
} from "Infrastructure/Api/Api";
import { Link } from "Navigation/Link";
import { getContextProfilePhotoUrl } from "Utils/Image/getProfilePhotoUrl";
import type { ViewerTransactionDirection } from "Utils/TransactionUtils";
import { appUrl } from "Utils/UrlUtils";

type Props = {
  item: TransactionItemType;
  direction: ViewerTransactionDirection;
  isBottomBorderHidden?: boolean;
  isInverseTransaction?: boolean;
};

export const TransactionItem = ({
  item: {
    amount,
    dateCreated,
    publicID,
    status,
    facilityPublicID,
    merchantIdentityUserPublicID,
    merchantProfilePicture,
    isRefund,
    relatedTransactionStatus,
  },
  direction,
  isBottomBorderHidden,
  isInverseTransaction,
}: Props) => {
  const bottomBorder = isBottomBorderHidden
    ? undefined
    : `1px solid ${Colors.MediumGrey}`;

  // Facility logo first; otherwise the merchant's image, which is the founder Merchant
  // persona's avatar (ZS-1607).
  const imageSrc = facilityPublicID
    ? `${getApiUrl()}${getMerchantsFacilitiesFacilityPublicIDLogoPath(facilityPublicID)}`
    : getContextProfilePhotoUrl(
        merchantIdentityUserPublicID,
        merchantProfilePicture,
      );

  const isMerchantImageVisible =
    direction === TransactionDirection.Outgoing &&
    !isInverseTransaction &&
    !!imageSrc;

  return (
    <Link
      to={`${appUrl("transaction-detail")}/${publicID}`}
      style={{ all: "unset" }}
    >
      <Box
        component="span"
        display="flex"
        width="100%"
        mt={2.5}
        pb={1.5}
        sx={{ cursor: "pointer" }}
        borderBottom={bottomBorder}
        justifyContent="space-between"
      >
        <Box component="span" display="flex" alignItems="center" gap={4}>
          {isMerchantImageVisible ? (
            <Avatar
              alt="Merchant"
              src={imageSrc}
              sx={{ width: 34, height: 34, bgcolor: Colors.White }}
            />
          ) : (
            <DirectionIcon
              direction={direction}
              isInverseTransaction={isInverseTransaction}
            />
          )}
          <TransactionDetails
            direction={direction}
            publicID={publicID}
            status={status}
            isRefund={isRefund}
            relatedTransactionStatus={relatedTransactionStatus}
          />
        </Box>
        <AmountWithDate
          dateCreated={dateCreated}
          amount={amount}
          direction={direction}
        />
      </Box>
    </Link>
  );
};
